module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(!model.active){\n%>\n<div class=\"inactive\"></div>\n<%\n}\nelse {\nvar hoverImageUrl = 'none';\nif(environment.style == 'desktop'){\nvar hoverImage = (helpers.detectRenderedImage(model.hoverImage, model._hoverImage) || {}).rendered || {};\nif(hoverImage.url){\nhoverImageUrl = 'url(' + hoverImage.url + ')';\n}\n}\n%>\n<div style=\"background-image: <%- hoverImageUrl %>;\">\n<%- helpers.renderSection(); %>\n</div>\n<%\n}\n%>"
  , __filename = "components/templates/window/window.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(!model.active){

    ; __line = 3
    ; __append("\n<div class=\"inactive\"></div>\n")
    ; __line = 5
    ; 
}
else {
var hoverImageUrl = 'none';
if(environment.style == 'desktop'){
var hoverImage = (helpers.detectRenderedImage(model.hoverImage, model._hoverImage) || {}).rendered || {};
if(hoverImage.url){
hoverImageUrl = 'url(' + hoverImage.url + ')';
}
}

    ; __line = 15
    ; __append("\n<div style=\"background-image: ")
    ; __line = 16
    ; __append( hoverImageUrl )
    ; __append(";\">\n")
    ; __line = 17
    ; __append( helpers.renderSection() )
    ; __append("\n</div>\n")
    ; __line = 19
    ; 
}

    ; __line = 21
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/window/window.ejs

}